/**
 * Managed-file storage boundary.
 *
 * All paths are RELATIVE to the Berrier Reno app-data root (forward
 * slashes). The database only ever stores these relative paths — never
 * machine-specific absolute paths — so data stays portable (spec §10, §44).
 *
 * Production: Tauri fs plugin rooted at the app-data directory.
 * Tests: Node fs rooted at a temp directory.
 */
export interface FileStore {
  writeFile(relativePath: string, bytes: Uint8Array): Promise<void>;
  readFile(relativePath: string): Promise<Uint8Array>;
  exists(relativePath: string): Promise<boolean>;
  removeFile(relativePath: string): Promise<void>;
  /** Absolute OS path for opening with external apps / display. */
  absolutePath(relativePath: string): Promise<string>;
}

/** SHA-256 hex digest via Web Crypto (available in WebView2 and Node 19+). */
export async function sha256Hex(bytes: Uint8Array): Promise<string> {
  const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength) as ArrayBuffer;
  const digest = await crypto.subtle.digest("SHA-256", buffer);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function timestampForFilename(d: Date = new Date()): string {
  const p = (n: number) => n.toString().padStart(2, "0");
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
}
